export default __webpack_public_path__ + "static/media/LEGO.14e43423.svg";